import { createSlice } from "@reduxjs/toolkit";
import { fetchVendorsonhomeItems } from "./VendorsonhomeThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const vendorsonhomeSlice = createSlice({
  name: "vendorsonhome",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchVendorsonhomeItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorsonhomeItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchVendorsonhomeItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendorsonhomeSlice.reducer;